module.exports = __webpack_public_path__ + "img/nicéphore-niépce.366deadd.png";